import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import SubredditPage from './pages/SubredditPage';
import AuthCallback from './pages/AuthCallback';
import AdminPage from './pages/AdminPage';
import TrendsPage from './pages/TrendsPage';
import SiteAdminPage from './pages/SiteAdminPage';
import PlacePage from './pages/PlacePage';
import PlaceBrowsePage from './pages/PlaceBrowsePage';
import PlaceLeaderboardPage from './pages/PlaceLeaderboardPage';
import PlaceTimelapsePage from './pages/PlaceTimelapsePage';
import { isSubdomainPattern } from './utils/subreddit';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#129CCE', // Cyan blue shade
      light: '#4AB8E0',
      dark: '#0D7FA3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0079d3', // Reddit blue
    },
  },
});

/** Routes for ncaaw.flairwizard.com — subreddit comes from the hostname. */
function TenantFlairwizardRoutes() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/site-admin" element={<SiteAdminPage />} />
      <Route path="/trends" element={<TrendsPage />} />
      <Route path="/place" element={<Navigate to="/place/browse" replace />} />
      <Route path="/place/leaderboard" element={<PlaceLeaderboardPage />} />
      <Route path="/place/timelapse" element={<PlaceTimelapsePage />} />
      <Route path="/place/browse" element={<PlaceBrowsePage />} />
      <Route path="/place/:flairCode" element={<PlacePage />} />
      <Route path="/admin/*" element={<AdminPage />} />
      <Route path="/" element={<SubredditPage />} />
    </Routes>
  );
}

/** Default: path-based /:subreddit (e.g. redditflair.redditcfb.com/ncaaw after legacy redirect). */
function PathBasedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin/:subreddit" element={<AdminPage />} />
      <Route path="/site-admin" element={<SiteAdminPage />} />
      <Route path="/:subreddit/trends" element={<TrendsPage />} />
      <Route path="/place" element={<Navigate to="/place/browse" replace />} />
      <Route path="/place/leaderboard" element={<PlaceLeaderboardPage />} />
      <Route path="/place/timelapse" element={<PlaceTimelapsePage />} />
      <Route path="/place/browse" element={<PlaceBrowsePage />} />
      <Route path="/:subreddit/place/leaderboard" element={<PlaceLeaderboardPage />} />
      <Route path="/:subreddit/place/timelapse" element={<PlaceTimelapsePage />} />
      <Route path="/:subreddit/place/browse" element={<PlaceBrowsePage />} />
      {/* Same as tenant /place/:flairCode — subreddit defaults to cfb via PlacePage + getSubredditFromUrl */}
      <Route path="/place/:flairCode" element={<PlacePage />} />
      <Route path="/:subreddit/place/:flairCode" element={<PlacePage />} />
      <Route path="/:subreddit" element={<SubredditPage />} />
    </Routes>
  );
}

function AppRouter() {
  if (typeof window !== 'undefined' && isSubdomainPattern()) {
    return <TenantFlairwizardRoutes />;
  }
  return <PathBasedRoutes />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Router>
            <AppRouter />
          </Router>
        </Box>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
